export default __webpack_public_path__ + "CircularCustCapNum-Book.cc43fb8b1f38fa218c0548c58e846826.woff2";